import _extends from "@babel/runtime/helpers/esm/extends";
import cloneDeep from 'lodash/cloneDeep';
export var transformSpace = function transformSpace(tokens) {
  var NUMBER_ITERATIONS = 13;
  var n = 0;
  var output = [];

  while (n < NUMBER_ITERATIONS) {
    output.push(n * tokens.value);
    n++;
  }

  return output;
}; // Generic

export var transformValueWithUnit = function transformValueWithUnit(tokens) {
  var output = {};
  tokens.map(function (_ref) {
    var name = _ref.name,
        value = _ref.value,
        unit = _ref.unit;
    return output[name] = "".concat(value).concat(unit);
  });
  return output;
};
export var transformLineHeights = function transformLineHeights(tokens) {
  var output = {};
  tokens.map(function (_ref2) {
    var name = _ref2.name,
        lineHeight = _ref2.lineHeight;
    return output[name] = lineHeight;
  });
  return output;
};
export var transformNameAndValue = function transformNameAndValue(tokens) {
  var output = {};
  tokens.map(function (_ref3) {
    var name = _ref3.name,
        value = _ref3.value;
    return output[name] = value;
  });
  return output;
};
export var transformColors = function transformColors(_ref4) {
  var theme = _ref4.theme,
      palette = _ref4.palette;
  var mainOutput = {}; // Extract each swatch from a category

  var _extractPaletteSwatches = function _extractPaletteSwatches(category) {
    var output = {};
    palette[category].forEach(function (swatch) {
      output[swatch.codeName] = '#' + swatch.hex;
    });
    return output;
  };

  var _extractThemeColors = function _extractThemeColors() {
    var output = cloneDeep(theme);
    Object.keys(theme).map(function (swatchName) {
      return swatchName === 'modes' ? Object.keys(theme.modes).map(function (mode) {
        Object.keys(output.modes[mode]).map(function (subSwatch) {
          output.modes[mode][subSwatch] = '#' + theme.modes[mode][subSwatch].hex;
        });
      }) : output[swatchName] = '#' + theme[swatchName].hex;
    });
    return output;
  }; // Map over each 'category' of colors in the palette


  Object.keys(palette).map(function (category) {
    var label = category.toLowerCase();
    mainOutput[label] = _extractPaletteSwatches(category);
  });
  return _extends({}, _extractThemeColors(), {
    extended: mainOutput
  });
};